import { docs } from '../config';
import css from './links.module.scss';

export function Links() {
    return (
        <div className={css.links}>
            <p>Quick Links</p>

            <ul>
                {docs.links.map(link => (
                    <li key={link.title} className={css.item}>
                        <span>{link.icons}</span>
                        <a target="_blank" href={link.url}>
                            {link.title}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
}
